/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'analytics',
    //     title: 'Analytics',
    //     type: 'group',
    //     icon: 'device_hub',
    //     children: [
    //         {
    //             id: 'dashboards',
    //             title: 'Dashboards',
    //             type: 'basic',
    //             icon: 'dashboard',
    //             link: '/dashboard'
    //         },
            {
                id: 'home',
                title: 'Home',
                type: 'basic',
                icon: 'home',
                link: '/home'},
    {
        id: 'accounts',
        title: 'Accounts',
        type: 'basic',
        icon: 'settings',
        link: '/accounts'},
    //     ]
    // },
    {
        id: 'acd',
        title: 'ACD',
        type: 'group',
        icon: 'device_hub',
        children: [
            {
                id: 'skillsmenu',
                title: 'Skills / Queues',
                //   translate: 'NAV.SKILLS.TITLE',
                type: 'collapsable',
                icon: 'build',
                children: [
                    {
                        id: 'skills',
                        title: 'Skills',
                        //   translate: 'NAV.SKILLS.TITLE',
                        type: 'basic',
                        icon: 'swap_horiz',
                        link: '/skills',
                    },
                    {
                        id: 'campaigns',
                        title: 'Campaigns',
                        // translate: 'NAV.CAMPAIGNS.TITLE',
                        type: 'basic',
                        icon: 'call_merge',
                        link: '/campaigns',
                    },
                    {
                        id: 'dispositions',
                        title: 'Dispositions',
                        // translate: 'NAV.DISPOSITIONS.TITLE',
                        type: 'basic',
                        icon: 'check_circle_outline',
                        link: '/dispositions',
                    },
                    // {
                    //     id: 'digital-tags',
                    //     title: 'Digital Tags',
                    //     // translate: 'NAV.DISPOSITIONS.TITLE',
                    //     type: 'basic',
                    //     icon: 'tag',
                    //     link: '/digital-tags',
                    // },
                    // {
                    //     id: 'configurationgroups',
                    //     title: 'Config Groups',
                    //     type: 'basic',
                    //     icon: 'call_merge',
                    //     link: '/config-groups',
                    // }
                ]
            },
            {
                id       : 'dialer',
                title    : 'Personal Connection',
                type     : 'collapsable',
                icon     : 'flash_on',
                children : [
                    //         {
                    //             id       : 'outbound-control',
                    //             title    : 'Outbound Control',
                    //             type     : 'basic',
                    //             icon     : 'build',
                    //             link      : '/outbound-control',
                    //         },
                    //         {
                    //             id       : 'proactive-xs',
                    //             title    : 'Proactive XS Automation',
                    //             type     : 'basic',
                    //             icon     : 'autorenew',
                    //             link      : '/proactive-xs',
                    //         },
                    {
                        id       : 'calling-lists',
                        title    : 'Calling Lists',
                        type     : 'basic',
                        icon     : 'list',
                        link      : '/calling-lists',
                    },
                    {
                        id       : 'dncGroups',
                        title    : 'Do Not Call Lists',
                        type     : 'basic',
                        icon     : 'not_interested',
                        link      : '/dnc-groups',
                    }
                ]
            },
            {
                id       : 'routing',
                title    : 'Routing',
                type     : 'collapsable',
                icon     : 'device_hub',
                children: [
                    {
                        id       : 'pointsOfContact',
                        title    : 'PointsOfContact',
                        // translate: 'NAV.POINTS.TITLE',
                        type     : 'basic',
                        icon     : 'place',
                        link      : '/points-of-contact',
                    },
                    {
                        id: 'scripts',
                        title: 'Studio Scripts',
                        type: 'basic',
                        icon: 'code',
                        link: '/studio-scripts'
                    },
                    // {
                    //     id: 'ivrSankey',
                    //     title: 'IVR Sankey',
                    //     type: 'basic',
                    //     icon: 'directions',
                    //     link: '/ivr-sankey'
                    // },
                    {
                        id: 'hours',
                        title: 'Hours Of Operation',
                        type: 'basic',
                        icon: 'access_time',
                        link: '/hours-of-operation'}
                ]
            },
            {
                id       : 'users',
                title    : 'User Configuration',
                type     : 'collapsable',
                icon     : 'people',
                children : [
                    {
                        id: 'users',
                        title: 'Users',
                        type: 'basic',
                        icon: 'person',
                        link: '/users'},
                    {
                        id: 'teams',
                        title: 'Teams',
                        type: 'basic',
                        icon: 'group',
                        link: '/teams'},
                    {
                        id: 'unavailable-codes',
                        title: 'Unavailable Codes',
                        type: 'basic',
                        icon: 'free_breakfast',
                        link: '/unavailable-codes'},
                    {
                        id: 'address-books',
                        title: 'Address Books',
                        type: 'basic',
                        icon: 'contact_phone',
                        link: '/address-books'},
                    {
                        id: 'securityProfileMatrix',
                        title: 'Profile Matrix',
                        type: 'basic',
                        icon: 'lock',
                        link: '/profile-matrix'}
                ]
            },
            // {
            // id: 'data',
            // title: 'Data',
            // type: 'collapsable',
            // icon: 'settings',
            // children: [
            {
                id: 'file-manager',
                title: 'File Manager',
                type: 'basic',
                icon: 'folder',
                link: '/apps/file-manager'
            }
            //         ]
            // }
        ]
    },
    {
        id       : 'skybox-products',
        title    : 'Skybox Products',
        type     : 'group',
        icon     : 'device_hub',
        children : [
            {
                id: 'SiX',
                title: 'Skybox Integrated Agent',
                type: 'basic',
                icon: 'contact_phone',
                link: 'https://skyboxcommunications.com/skybox-servicenow-integrated-experience/',
                externalLink: true,
                target: '_blank'
            },
            {
                id: 'sky-data',
                title: 'SkyData ODBC Data Access',
                type: 'basic',
                icon: 'data_usage',
                link: 'sky-data'
                // link: 'https://skyboxcommunications.com/skybox-skydata/',
                // externalLink: true,
                // target: '_top'
            },
            {
                id: 'feedback',
                title: 'Feedback',
                type: 'basic',
                icon: 'feedback',
                link: '/feedback'
            }
        ]
    }
];
export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
